import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin
} from "antd";

//OTHER IMPORTS
import dayjs from 'dayjs';
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';


const { Text } = Typography

const AssignLoanOfficer = (props) => {

  const { userData, pageTitleParam } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [loanOfficerOptions, setLoanOfficerOptions] = useState([]);
  const [loanOfficerTemplate, setLoanOfficerTemplate] = useState([]);

  const dateFormat = 'YYYY/MM/DD';


  useEffect(() => {
    defaultDate()
    getTemplate();
    // console.log(pageTitleParam)
  }, []);

  const defaultDate = () => {
    form.setFieldsValue({
      assignmentDate: dayjs(),
    })
  }
  function getTemplate() {

    const params = {
      fields: "id,loanOfficerId,loanOfficerOptions",
      staffInSelectedOfficeOnly: true,
      template: true
    }
    const url = `${apiConfig.Loans}/${state.id}`

    let body = {
      session,
      params
    };

    setIsLoading(true)
    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false)
        const objList = res;
        setLoanOfficerTemplate(objList)

        const tempLoanOfficerOptions = []

        objList?.loanOfficerOptions?.forEach((element) =>
          tempLoanOfficerOptions.push({
            label: element?.displayName,
            value: element?.id
          })
        )

        setLoanOfficerOptions(tempLoanOfficerOptions)
      }
    });
  }

  function onCancel() {
    navigate("/detail-group-loan", { state: state });
  }

  // function handlePayloadData(valueParam) {
  //   if(pageTitleParam) {
  //     valueParam.fromLoanOfficerId = loanOfficerTemplate?.loanOfficerId
  //   } else {
  //     valueParam.fromLoanOfficerId = ""
  //   }
  // }

  const onSubmit = (formValues) => {

    delete formValues.approvedAmt

    // handlePayloadData(formValues)

    formValues.assignmentDate = BOM.DateTime(formValues.assignmentDate, "only-date")

    const params = {
      command: "assignloanofficer"
    }
    const url = `${apiConfig.Loans}/${state.id}`

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.assignLoanOfficerMsg);
        navigate("/detail-group-loan", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.assignLoanOfficer}
        pageItems={staticConfig.assignLoanOfficerBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            // initialValues={formData.customerAddressInfo}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row >
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.toLoanOfficer}
                  name={"toLoanOfficerId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.toLoanOfficer
                      ),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.toLoanOfficer,
                      "select"
                    )}
                    options={loanOfficerOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.assignmentDate}
                  name={"assignmentDate"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.assignmentDate
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.assignmentDate}`,
                      "select"
                    )}
                    style={{ width: '100%' }}
                    format={dateFormat}
                  />

                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("BULKREASSIGN_LOAN") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>

  )
}

export default AssignLoanOfficer